export default {"src":"/_next/static/media/modern-furniture.41c03660.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};